var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgUpload = function SvgUpload(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.00016 14.9012C3.2572 14.1421 2.69672 13.2239 2.36119 12.2162C2.02566 11.2084 1.92386 10.1375 2.06352 9.08452C2.20317 8.03157 2.58061 7.02422 3.16725 6.13875C3.75389 5.25329 4.53434 4.51293 5.44949 3.97377C6.36464 3.4346 7.39048 3.11077 8.44932 3.0268C9.50816 2.94282 10.5722 3.10091 11.5609 3.48908C12.5496 3.87725 13.437 4.48533 14.1559 5.26725C14.8748 6.04918 15.4063 6.98445 15.7102 8.00222H17.5002C18.4657 8.00211 19.4056 8.31254 20.1811 8.88766C20.9567 9.46278 21.5267 10.2721 21.8069 11.196C22.0872 12.12 22.0628 13.1095 21.7375 14.0186C21.4121 14.9276 20.803 15.7079 20.0002 16.2442M12 12.0002V21.0002M12 12.0002L15.9998 16.0002M12 12.0002L7.99982 16.0002",
    stroke: "#0A0A0A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUpload);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "Upload.8ca40a65b3d2529f90e32121ede6a830.svg";